import React from "react";
import Table from "../Table";

import { ShippingMethods } from "../../OrganizationCreateEditPage/ShipmentMethodSection";
import { Typography } from "antd";

import { Common } from "@secondcloset/types";
type RecommendedShipmentMethod = Common.Organization["recommended_shipping_methods"];

interface Props {
  shipmentMethods: RecommendedShipmentMethod;
  loading: boolean;
}

enum ShippingMethodLabel {
  parcel = "Parcel",
  freight = "3rd Party Freight",
  sc_last_mile = "GoBolt Freight",
}

const ShipmentMethodTable: React.FC<Props> = ({ shipmentMethods = {}, loading }) => {
  const dataSource = Object.entries(shipmentMethods)
    .map(([key, value]) => ({
      id: key,
      method: key,
      value,
    }))
    .filter((i) => typeof i.value === "boolean");

  const getShippingMethodLabel = (method: ShippingMethods) => ShippingMethodLabel[method];

  const columns = [
    {
      title: "Shipment Method",
      dataIndex: "method",
      key: "method",
      render(method: ShippingMethods) {
        return getShippingMethodLabel(method);
      },
    },
    {
      title: "Status",
      dataIndex: "value",
      key: "value",
      render(value: boolean) {
        return <Typography.Text type={value ? "success" : "warning"}>{value ? "Active" : "Archived"}</Typography.Text>;
      },
    },
    {
      title: "Service Tier",
      dataIndex: "method",
      render(method: ShippingMethods) {
        if (method === ShippingMethods.sc_last_mile && shipmentMethods?.sc_service_tier) {
          const noOfSelectedTiers = Object.values(shipmentMethods.sc_service_tier).filter(
            (isSelected) => isSelected
          ).length;
          return noOfSelectedTiers ? `${noOfSelectedTiers} Selected` : "N/A";
        }
        return "N/A";
      },
    },
  ];

  return (
    <Table
      tableProps={{
        columns,
        dataSource,
        loading,
      }}
      title="Shipment Method"
    />
  );
};

export default ShipmentMethodTable;
